import { CnIcon } from '@alife/cn-ui';
import React, { useEffect, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import './index.scss';
let zIndex = 1000;
function Panel(props) {
    const { header, title, children, visible, originRef, showClose = false, clickOutsideClose = true, onClose, } = props;
    const ref = useRef(null);
    useEffect(() => {
        if (visible && clickOutsideClose) {
            // console.log('click');
            const onClick = (e) => {
                const { target } = e;
                if (originRef?.current?.contains?.(target))
                    return;
                if (ref.current && !ref.current?.contains(target)) {
                    onClose?.();
                }
            };
            document.addEventListener('click', onClick, true);
            return () => {
                document.removeEventListener('click', onClick);
            };
        }
        return () => { };
    }, [visible, clickOutsideClose]);
    useEffect(() => {
        if (visible) {
            zIndex += 1;
            return () => {
                zIndex -= 1;
            };
        }
        return () => { };
    }, [visible]);
    return (React.createElement(CSSTransition, { in: visible, timeout: 200, classNames: 'cn-ui-panel-transition', unmountOnExit: true },
        React.createElement("div", { className: 'cn-ui-panel', ref: ref, style: {
                zIndex,
            } },
            !!(header || title) && (React.createElement("div", { className: 'cn-ui-panel-header' }, header ? header : title ? React.createElement("h3", null, title) : null)),
            !!showClose && React.createElement("span", { className: "cn-ui-panel-close-icon" },
                React.createElement(CnIcon, { type: 'close', size: "medium", onClick: onClose })),
            React.createElement("div", { className: 'cn-ui-panel-body' }, children))));
}
export default Panel;
